import Styled from 'styled-components';

const ProgressTrackerIndicator = Styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  svg {
    width: ${({ theme: { progressTracker } }) => progressTracker.svgCompletedWidth};
    height: ${({ theme: { progressTracker } }) => progressTracker.svgCompletedHeight};
    display: block;
  }
`;

export default ProgressTrackerIndicator;
